// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__ZTsVJ","colMaxWidth":"Table_colMaxWidth__88QQO"};